import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import {DxChartComponent, DxPivotGridComponent} from 'devextreme-angular';
import {durationToHoursStr, durationToStr} from 'shared';
import {filter, values, sum} from 'lodash';

const duration = (value) => {
  return durationToHoursStr(value) + ' h';
};

@Component({
  selector: 'app-fields-interventions-general-report',
  templateUrl: './fields-interventions-general-report.component.html',
  styleUrls: ['./fields-interventions-general-report.component.scss']
})
export class FieldsInterventionsGeneralReportComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  toolbarDs: DataSource;

  @Input()
  dataSource: PivotGridDataSource;

  @Input()
  currentReportType: any;

  @Input()
  reportCurrentViewModes: any;

  @ViewChild(DxChartComponent, {static: false})
  chart: DxChartComponent;

  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  @Input()
  width: number;

  @Input()
  height: number;

  chartHeight: number;

  constructor() {
  }

  ngOnInit(): void {

    // Set fields
    this.dataSource.fields([{
      caption: 'Domaine',
      width: 120,
      dataField: 'domain_name',
      area: 'row',
      sortBySummaryField: 'Total'
    }, {
      caption: 'Parcelle',
      dataField: 'field.name',
      width: 150,
      area: 'row'
    }, {
      caption: 'Culture',
      dataField: 'crop.name',
      width: 150,
      area: 'row'
    }, {
      caption: 'Puissance',
      dataField: 'engine_power_category',
      width: 150,
      area: 'row'
    }, {
      caption: 'Tracteur',
      dataField: 'tractor_name',
      width: 150,
      area: 'row'
    }, {
      caption: 'Outil',
      dataField: 'trailer_name',
      width: 150,
      area: 'row'
    }, {
      caption: 'Operation',
      dataField: 'trailer_operation_type',
      width: 150,
      area: 'row'
    }, {
      caption: 'Mois',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'month',
      area: 'column'
    }, {
      caption: 'Jour',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'day',
      area: 'column'
    }, {
      caption: 'Superficie Travaillée Ha',
      dataField: 'working_area_ha',
      dataType: 'number',
      summaryType: 'sum',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }, {
      caption: 'Superficie Cultivée Ha',
      // dataField: 'field_crop_cadastral_area',
      dataType: 'number',
      // summaryType: 'sum'
      summaryType: 'custom',
      calculateCustomSummary: (options) => {
        switch (options.summaryProcess) {
          case 'start':
            // Initializing "totalValue" here
            options.totalValue = {};
            break;
          case 'calculate':
            // Modifying "totalValue" here
            if (!options.totalValue.hasOwnProperty(options.value.field.id)) {
              options.totalValue[options.value.field.id] = options.value.field_crop_cadastral_area;
            }
            break;
          case 'finalize':
            // Assigning the final value to "totalValue" here
            options.totalValue = parseFloat(sum(values(options.totalValue)).toFixed(2));
            break;
        }
      },
      area: 'data'
    }, {
      caption: 'Debit horaire Ha/h',
      dataField: 'working_hectare_per_hour',
      dataType: 'number',
      summaryType: 'avg',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }, {
      caption: 'Consommation Carburant L',
      dataField: 'metrics.fuel_total_consumption_all',
      dataType: 'number',
      format: {type: 'fixedPoint', precision: 2},
      summaryType: 'sum',
      area: 'data'
    }, {
      caption: 'Consommation Carburant L/Ha',
      dataField: 'fuel_total_consumption_per_hectare',
      dataType: 'number',
      format: {type: 'fixedPoint', precision: 2},
      summaryType: 'avg',
      area: 'data'
    }, {
      caption: 'Consommation Carburant  L/h',
      dataField: 'metrics.fuel_hourly_consumption_rate_avg_all',
      dataType: 'number',
      summaryType: 'avg',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }, {
      caption: 'Carburant  Temperature',
      dataField: 'metrics.fuel_temperature_avg_all',
      dataType: 'number',
      summaryType: 'avg',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }, {
      caption: 'Heures Moteurs',
      dataField: 'metrics.engine_working_hours_all',
      dataType: 'number',
      summaryType: 'sum',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }, {
      caption: 'Temps total',
      dataField: 'total_duration',
      dataType: 'number',
      summaryType: 'sum',
      format: durationToStr,
      area: 'data'
    }, {
      caption: 'Temps Travail',
      dataField: 'total_working_duration',
      dataType: 'number',
      summaryType: 'sum',
      format: durationToStr,
      area: 'data'
    }, {
      caption: 'Temps d\'arrêt',
      dataField: 'stop_working_duration',
      dataType: 'number',
      summaryType: 'sum',
      format: durationToStr,
      area: 'data',
    }, {
      caption: 'Arret / Travail  %',
      dataField: 'stop_working_duration_percent',
      dataType: 'number',
      summaryType: 'avg',
      format: 'percent',
      area: 'data'
    }, {
      caption: 'Temps Trajet',
      dataField: 'total_road_duration',
      dataType: 'number',
      summaryType: 'sum',
      format: durationToStr,
      area: 'data'
    }, {
      caption: 'Vitesse moyenne au travail KM/H',
      dataField: 'working_in_field_speed_avg',
      dataType: 'number',
      summaryType: 'avg',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }]);

    this.chartHeight = filter(this.dataSource.fields(), (f) => {
      return f.area === 'data' && f.visible !== false;
    }).length * 350;

    this.toolbarDs.store().push([{
      type: 'update',
      data: {
        options: {
          onClick: () => {
            this.pivotGrid.instance.getFieldChooserPopup().show();
          }
        }
      },
      key: 'filter',
    },
      {
        type: 'update',
        data: {
          options: {
            onClick: () => {
              this.dataSource.reload();
            }
          }
        },
        key: 'refresh',
      }]);
  }

  ngAfterViewInit(): void {
    this.pivotGrid.instance.bindChart(this.chart.instance, {
      dataFieldsDisplayMode: 'splitPanes',
      alternateDataFields: false,
      customizeSeries: (seriesName, seriesOptions) => {
        return seriesOptions; // This line is optional
      }
    });

    // Assign the data source
    this.pivotGrid.instance.option('dataSource', this.dataSource);
  }

  ngOnDestroy(): void {
  }
}
